import styled from "styled-components";

export const PopupListStyled = styled.div`
  .custom-select__body {
    max-height: 155px;
  }

  .popup-form__item--row {
    .custom-select__head {
      justify-content: space-between;
    }
  }


  @media screen and (max-width: 992px) {
    .profile .popup-container {
      overflow: hidden;
    }
  }
`
